import { styled, Box, Tab, Modal } from '@mui/material';
import { COLORS } from '../../../utils/colors';

export const useHomeStyles = () => {
  return {
    fetching: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 'calc(100vh - 108px)',
      width: '100%',
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      bgcolor: COLORS.WHITE,
      height: '100%',
    },
    container: {
      display: 'grid',
      placeItems: 'center',
      height: '80vh',
      width: '100%',
    },
    tabsWrapper: {
      width: '100%',
      boxShadow: '0 0.3125rem 0.9375rem 0 rgba(227, 227, 227, 0.5)',
      display: 'flex',
      alignItems: 'flex-end',
    },
    menuItem: {
      cursor: 'pointer',
      marginTop: '0',
      padding: '.75rem 1.4375rem',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    },
    logout: {
      cursor: 'pointer',
      marginTop: '1rem',
      paddingTop: '1rem',
      borderTop: `1px solid ${COLORS.MEDIUM_GRAY}`,
    },
  };
};

export const StyledModal = styled(Box)({
  position: 'absolute',
  top: '3.625rem',
  right: '2.5rem',
  height: '15rem',
  width: '14rem',
  backgroundColor: COLORS.WHITE,
  boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.26)',
  padding: 0,
  margin: 0,
  borderRadius: '0 0 .75rem .75rem',
});

export const StyledOverlay = styled(Modal)({
  '& .MuiModal-backdrop': {
    background: 'transparent',
  },
});

export const StyledTabsWrapper = styled(Box)({
  width: '100%',
  boxShadow: '0 0.3125rem 0.9375rem 0 rgba(227, 227, 227, 0.5)',
  display: 'flex',
  alignItems: 'flex-end',
  position: 'sticky',
  top: '3.625rem',
  zIndex: 99,
  backgroundColor: COLORS.WHITE,
  paddingTop: '0.75rem',
  height: '3.125rem',
});

export const StyledTabs = styled(Box)({
  padding: '0 2.25rem',
  '& .MuiTabs-indicator': {
    backgroundColor: COLORS.PRIMARY,
  },
  '& .MuiTab-root.Mui-selected': {
    color: COLORS.PRIMARY,
  },
});

export const StyledTab = styled(Tab)({
  textTransform: 'none',
  fontSize: '0.9375rem',
  fontWeight: 600,
});
